<template>
  <span></span>
</template>

<script>
import eventBus from '@refapp/eventbus-js';

export default {
  name: 'rfp-ratings-tags',
  props: {
    writeReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
    likeReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
    readReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
    sortReviewsTags: {
      type: Object,
      default() {
        return {};
      },
    },
    productName: {
      type: String,
      required: true,
    },
    postReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
    productId: {
      type: String,
      required: true,
    },
    unhelpfulReviewTags: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      overallRatingReview: 0,
      overridenProductId: '',
      overridenProductName: '',
    };
  },
  created() {
    window.eventBus.$on('rfp-product-variant-data-update', ({ ean, name }) => {
      if (ean) {
        this.overridenProductId = ean;
      }
      if (name) {
        this.overridenProductName = name;
      }
    });

    if (this.writeReviewTags) {
      eventBus.on('WriteReviewTags', (val) => {
        this.datalayerEventsTrigger(this.writeReviewTags, val);
      });
    }
    if (this.likeReviewTags) {
      eventBus.on('LikeReviewTags', () => {
        this.datalayerEventsTrigger(this.likeReviewTags, '');
      });
    }
    if (this.unhelpfulReviewTags) {
      eventBus.on('unLikeReviewTags', () => {
        this.datalayerEventsTrigger(this.unhelpfulReviewTags, '');
      });
    }
    if (this.readReviewTags) {
      eventBus.on('readReviewTags', () => {
        this.datalayerEventsTrigger(this.readReviewTags, '');
      });
    }
    if (this.sortReviewsTags) {
      ['sortReviewsTags', 'filter-action-triggered'].forEach((eventItem) => {
        eventBus.on(eventItem, (displayDatas) => {
          this.datalayerEventsTrigger(this.sortReviewsTags, displayDatas);
        });
      });
    }
    if (this.postReviewTags) {
      eventBus.on('PostReviewTags', (noOfStars) => {
        this.overallRatingReview = noOfStars;
        this.datalayerEventsTrigger(this.postReviewTags, noOfStars);
      });
    }
  },
  methods: {
    datalayerEventsTrigger(tags, values) {
      const placeholders = {
        PAGE_CATEGORY: '[page category]',
        CTA_NAME: '[cta name]',
        REVIEW_SELECTION: '[review selection]',
        PRODUCT_NAME: '[product name]',
        PRODUCT_ID: '[product id]',
        NUMBER_OF_STARS: '[number of stars]',
      };

      let originalMsg = JSON.stringify(tags);
      if (originalMsg.includes(placeholders.PAGE_CATEGORY)) {
        if (window.wsf?.pageCategory) {
          originalMsg = originalMsg.replaceAll(
            placeholders.PAGE_CATEGORY,
            window.wsf.pageCategory.toLowerCase(),
          );
        } else {
          originalMsg = originalMsg.replaceAll(placeholders.PAGE_CATEGORY, '');
        }
      }

      if (originalMsg.includes(placeholders.CTA_NAME)) {
        if (values != undefined) {
          originalMsg = originalMsg.replaceAll(placeholders.CTA_NAME, values.toLowerCase());
        } else {
          originalMsg = originalMsg.replaceAll(placeholders.CTA_NAME, '');
        }
      }
      if (originalMsg.includes(placeholders.REVIEW_SELECTION)) {
        if (values != undefined) {
          originalMsg = originalMsg.replaceAll(placeholders.REVIEW_SELECTION, values.toLowerCase());
        } else {
          originalMsg = originalMsg.replaceAll(placeholders.REVIEW_SELECTION, '');
        }
      }

      if (originalMsg.includes(placeholders.PRODUCT_NAME)) {
        if (this.productName != undefined) {
          originalMsg = originalMsg.replaceAll(
            placeholders.PRODUCT_NAME,
            (this.overridenProductName || this.productName).toLowerCase(),
          );
        } else {
          originalMsg = originalMsg.replaceAll(placeholders.PRODUCT_NAME, '');
        }
      }
      if (originalMsg.includes(placeholders.PRODUCT_ID)) {
        originalMsg = originalMsg.replaceAll(
          placeholders.PRODUCT_ID,
          this.overridenProductId || this.productId || '',
        );
      }
      if (originalMsg.includes(placeholders.NUMBER_OF_STARS)) {
        if (this.overallRatingReview != undefined) {
          originalMsg = originalMsg.replaceAll(
            placeholders.NUMBER_OF_STARS,
            this.overallRatingReview,
          );
        } else {
          originalMsg = originalMsg.replaceAll(placeholders.NUMBER_OF_STARS, '');
        }
      }

      originalMsg = originalMsg.replaceAll('\n', '');
      window.dataLayer ||= [];
      window.dataLayer.push(JSON.parse(originalMsg));
    },
  },
};
</script>
